/**
 * ProtectedRoute — Redirects to /lookup when no valid session exists.
 */

import { Navigate, useLocation } from 'react-router-dom';
import { usePortal } from '../../context/PortalContext';

export function ProtectedRoute({ children }) {
    const { meta } = usePortal();
    const location = useLocation();

    if (!meta.isAuthenticated) {
        return (
            <Navigate
                to="/lookup"
                state={{ from: location, expired: meta.isSessionExpired }}
                replace
            />
        );
    }

    return children;
}
